import { FC } from 'react';
import classNames from 'classnames';
import ConfirmEmail from './ConfirmEmail';

import { selectUserData } from 'store/user/userSlice';
import { useAppSelector } from 'store/hooks';
// import { INotificationItem } from 'interfaces/notifications.interface';

import styles from './notification-bar.module.css';
import TrialNotification from './TrialNotification';

interface NotificationBarProps {
  // items: INotificationItem[]
}

const NotificationBar: FC<NotificationBarProps> = () => {
  const user = useAppSelector(selectUserData);
  const trialDays = user?.alertMessage ? Number(user.alertMessage) : undefined;

  if (!user) return null;

  return (
    <div className={styles.root}>
      {!user.emailConfirmed && (
        <div className={classNames(styles.item, styles.SUCCESS)}>
          <ConfirmEmail email={user.login} />
        </div>
      )}
      {(trialDays || trialDays === 0) && (
        <div className={classNames(styles.item, trialDays < 4 ? styles.ERROR : (trialDays < 7 ? styles.ALERT : styles.SUCCESS))}>
          <TrialNotification trialDays={trialDays} />
        </div>
      )}
    </div>
  );
};

export default NotificationBar;
